import { Box, Typography } from "@mui/material"
import { useState } from "react"
import { AudienceAwareAmendsEditor } from "authoring/routes/project/amends/components/audience-aware-amends-editor"
import { buildAudienceAmendsPayload } from "authoring/routes/project/amends/lib/audience-aware-amends.mjs"
import { useOkCancelContext } from "lib/@hooks/useOkCancelContext"

export function DeleteTaskAmendsDialog({ taskTitle, initialNoteData, macroMap, ok, cancel }) {
    const [noteData, setNoteData] = useState(() => buildAudienceAmendsPayload(initialNoteData ?? {}))
    const { ok: contextConfirm, cancel: contextClose } = useOkCancelContext()
    const confirm = ok ?? contextConfirm
    const close = cancel ?? contextClose

    return (
        <Box sx={{ p: 3 }} data-cy="delete-task-amends-dialog">
            <Typography variant="h5">Delete Task</Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
                Add author notes before removing{taskTitle ? ` "${taskTitle}"` : " this task"} from the draft.
            </Typography>

            <Box mt={2}>
                <AudienceAwareAmendsEditor
                    subtitle="This is required to explain why the task is being removed."
                    noteData={noteData}
                    macroMap={macroMap}
                    onChange={setNoteData}
                    onCancel={close}
                    onSave={confirmDelete}
                    saveCaption="Confirm"
                />
            </Box>
        </Box>
    )

    function confirmDelete() {
        if (typeof confirm === "function") {
            return confirm({ noteData })
        }
        if (typeof close === "function") {
            close()
        }
        return undefined
    }
}
